<template>
  <view class="service-business" id="makeorder-travel-service">
    <!--多个增值服务-->
    <block wx:if="{{ rightsInfo.length > 1}}">
      <mulit-service bind:selectService="selectService" bind:openRightsDescDrawer="openRightsDescDrawer" />
    </block>
    <!--单个增值服务-->
    <block wx:else>
      <single-service bind:selectService="selectService" bind:openRightsDescDrawer="openRightsDescDrawer" />
    </block>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { cloneDeep } from 'lodash'
  import { createObserver } from '@/common/observer'
  import { trackEvent } from '@/common/track'

  const TRACK_SERVICE_TYPE_MAP = {
    1: 'nologin',
    2: 'noworries'
  }
  createComponent({
    props: {
      },
    data() {
      return {
        observer: null,
        originalRightInfo: [{}] // 坐席页面选中的权益数据
      }
    },
    computed: {
      ...store.mapState({
        hasLogin: 'login12306.is12306Login',
        selectSeatInfo: 'train.selectSeatInfo', // 选中的坐席数据
        selectRightInfo: 'train.selectRightInfo' // 选中的权益卡数据
      }),
      rightsInfo() { // 普通预定辅营商品
        return this.selectSeatInfo?.[0]?.service_info?.makeOrderServiceInfoList ?? []
      },
      selectedType() { // 1便携购票 2退改无忧 3普通预定
        return this.selectRightInfo[0]?.type
      }
    },
    watch: {
      rightsInfo: {
        immediate: true,
        deep: true,
        handler(newVal, oldVal) {
          const servicetype = newVal.map(item => {
            return TRACK_SERVICE_TYPE_MAP[item.type]
          }).join('、')
          this.$nextTick(() => {
            this.observer && this.observer.closeObserver()
            this.observer = createObserver({
              element: 'makeorder-travel-service',
              key: 'yks_train_conorder_service_sw',
              name: '迎客松-火车票-确认订单页-出行服务-曝光',
              params: {
                servicetype
              }, // this.trackParams,
              continued: true,
              threshold: 0.75
            })
          })
        }
      }
    },
    methods: {
      ...store.mapMutations({
        setSelectRightInfo: 'train.setSelectRightInfo',
        setAddedServiceSource: 'makeOrder.setAddedServiceSource',
        setMakeOrderLoginType: 'makeOrder.setMakeOrderLoginType',
      }),
      // 选择辅营商品
      selectService(e) {
        const item = e?.detail || {}
        const type = this.selectRightInfo[0]?.type
        if (type === 3) {
          this.originalRightInfo = cloneDeep(this.selectRightInfo) // 记录坐席页面选中权益卡信息
        }

        const trackParams = {
          servicetype: TRACK_SERVICE_TYPE_MAP[item.type], // noworries：退改无忧 nologin：免登搭售
          // button: '', // add：预定 cancel：取消 show：产品说明
        }
        // 未登录且选了非12306购票，买线下票setMakeOrderLoginType(1) 0-12306流程 1-免登录流程
        if (this.selectedType === item.type) { // 取消选中
          this.setAddedServiceSource([])
          this.setMakeOrderLoginType(0)
          this.setSelectRightInfo(this.originalRightInfo)
          trackParams.button = 'cancel'
        } else { // 选中
          const added_service_map = {
            1: 'make_order__nologin',
            2: 'make_order__noworries',
            3: ''
          }
          this.setAddedServiceSource([added_service_map[item.type]])
          !this.hasLogin && this.setMakeOrderLoginType(1)
          // 普通预定增加选中辅营商品
          this.setSelectRightInfo([item])
          trackParams.button = 'add'
        }
        trackEvent('yks_train_conorder_service_ck', '迎客松-火车票-确认订单页-出行服务-点击', trackParams)
      },
      openRightsDescDrawer(e) {
        const type = e?.detail
        const trackParams = {
          servicetype: TRACK_SERVICE_TYPE_MAP[type], // noworries：退改无忧 nologin：免登搭售
          button: 'show', // add：预定 cancel：取消 show：产品说明
        }
        trackEvent('yks_train_conorder_service_ck', '迎客松-火车票-确认订单页-出行服务-点击', trackParams)
        this.triggerEvent('openRightsDescDrawer', type)
      }
    }
  })
</script>

<style scoped lang="stylus">
  .service-business
    margin-top 10px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'mulit-service': './mulit-service',
      'single-service': './single-service'
    }
  }
</script>